import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { Observable, map } from 'rxjs';
import { IResponse } from '../models/response';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class ApprovalService {

  constructor(private _http: HttpClient) { }

  getApprovalRequests(page: any, take: any, search: any, department: string, room: string, approvalstatus: any, project: string, jsnId?: string, fetchReport?: any,): Observable<any> {
    let params = {
      department,
      room,
      approvalstatus,
      project,
      search
    }
    if (page) {
      params['page'] = page;
    }
    if (take) {
      params['take'] = take;
    }
    if (jsnId) {
      params['jsn'] = jsnId;
    }
    if (fetchReport) {
      params['report'] = true
    }
    return this._http.get(apiconstants.API_APPOROVAL_REQUESTS, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getApprovalRequestsBySessionId(page: any, take: any, sessionId: string,) {
    let params = {}
    if (page) {
      params['page'] = page;
    }
    if (take) {
      params['take'] = take;
    }

    return this._http.get(apiconstants.API_SESSION_APPOROVAL_REQUEST + '/' + sessionId, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  processRequest(requestId, params) {
    return this._http.put(apiconstants.API_APPOROVAL_REQUESTS + '/' + requestId, params, {
      headers: { loader: "false" },
    }).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  shareRequest(params): Observable<any> {
    return this._http.post(apiconstants.API_SHARE_REQUEST + '/', params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

}
